import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
export { default } from "./PayPal";

export const typeGuard = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "paypal" ?? false;
};
